import Icon from '../components/Icon';
import PlaceImage from '../components/PlaceImage';
import React, { useState } from 'react';
import './MapPlaces.css';

const WA = '919445879508';

/* ─── All Kodaikanal Tourist Places with coordinates (relative %) ─── */
const PLACES = [
  {
    id: 1, name: "Coaker's Walk", category: 'Viewpoint',
    emoji: 'compass', top: 38, left: 52,
    desc: "A 1-km scenic walk along the edge of the hills with breathtaking valley views. Best at sunrise with misty clouds below.",
    timing: '6:00 AM – 7:00 PM', entry: '₹30/person', duration: '1–2 hrs',
    highlight: 'Best sunrise spot in Kodaikanal',
    img:'/images/destinations/coaker-s-walk.jpg',
  },
  {
    id: 2, name: 'Kodai Lake', category: 'Lake',
    emoji: 'compass', top: 45, left: 48,
    desc: "A star-shaped man-made lake at the heart of Kodaikanal. Enjoy boating, cycling, and horse riding around its 5-km perimeter.",
    timing: '9:00 AM – 6:00 PM', entry: 'Free (boat ₹100+)', duration: '2–3 hrs',
    highlight: 'Star-shaped lake at town centre',
    img:'/images/destinations/kodai-lake.jpg',
  },
  {
    id: 3, name: 'Silver Cascade', category: 'Waterfall',
    emoji: 'compass', top: 72, left: 30,
    desc: "A beautiful 180-ft silver waterfall on the Kodaikanal–Palani road. The road-side falls are perfect for a refreshing stop.",
    timing: '6:00 AM – 6:00 PM', entry: 'Free', duration: '30–45 mins',
    highlight: '180-ft cascade off Palani Ghat',
    img:'/images/destinations/silver-cascade.jpg',
  },
  {
    id: 4, name: 'Pillar Rocks', category: 'Viewpoint',
    emoji: 'mountain', top: 55, left: 62,
    desc: "Three massive granite boulders standing 400 ft tall — a geological wonder. Stunning views of the valley below.",
    timing: '9:00 AM – 5:30 PM', entry: '₹30/person', duration: '1 hr',
    highlight: '400-ft granite monoliths',
    img:'/images/destinations/pillar-rocks.jpg',
  },
  {
    id: 5, name: 'Pine Forest', category: 'Nature',
    emoji: 'leaf', top: 30, left: 40,
    desc: "A magical dense forest of tall pine trees — perfect for a quiet walk, photography, and picnics in the cool mountain air.",
    timing: '6:00 AM – 6:00 PM', entry: 'Free', duration: '1–2 hrs',
    highlight: 'Enchanting pine-needle carpet',
    img:'/images/destinations/pine-forest.jpg',
  },
  {
    id: 6, name: "Dolphin's Nose", category: 'Viewpoint',
    emoji: 'compass', top: 62, left: 72,
    desc: "A dramatic cliff jutting out like a dolphin's nose — offering a spectacular 360° view of valleys and tea estates.",
    timing: '8:00 AM – 5:00 PM', entry: '₹20/person', duration: '1–2 hrs',
    highlight: 'Best panoramic valley view',
    img:'/images/destinations/dolphin-s-nose.jpg',
  },
  {
    id: 7, name: 'Guna Cave', category: 'Cave',
    emoji: 'compass', top: 48, left: 68,
    desc: "Also called Devil's Kitchen — a series of dark caverns in rocky terrain. Made famous by the Tamil film 'Guna'. Entry restricted but viewpoint accessible.",
    timing: '9:00 AM – 5:00 PM', entry: '₹25/person', duration: '45 mins',
    highlight: 'Iconic Bollywood film location',
    img:'/images/destinations/guna-cave.jpg',
  },
  {
    id: 8, name: 'Bryant Park', category: 'Garden',
    emoji: 'leaf', top: 42, left: 54,
    desc: "A beautifully maintained botanical garden with over 325 species of trees, 740 varieties of roses, and stunning flower beds.",
    timing: '9:00 AM – 6:00 PM', entry: '₹30 Adults / ₹10 Children', duration: '1–2 hrs',
    highlight: '325 tree species, 740 rose varieties',
    img:'/images/destinations/bryant-park.jpg',
  },
  {
    id: 9, name: 'Bear Shola Falls', category: 'Waterfall',
    emoji: 'compass', top: 35, left: 58,
    desc: "A picturesque seasonal waterfall surrounded by dense forest. Legend says bears used to come here to drink water.",
    timing: '8:00 AM – 5:00 PM', entry: '₹20/person', duration: '1 hr',
    highlight: 'Seasonal forest waterfall',
    img:'/images/destinations/bear-shola-falls.jpg',
  },
  {
    id: 10, name: 'Berijam Lake', category: 'Lake',
    emoji: 'compass', top: 68, left: 55,
    desc: "A pristine reserved forest lake accessible only with a Forest Dept permit. Crystal clear water surrounded by untouched nature.",
    timing: '9:00 AM – 3:00 PM (permit)', entry: 'Permit required (₹150)', duration: '3–4 hrs',
    highlight: 'Reserved forest — pristine waters',
    img:'/images/destinations/berijam-lake.jpg',
  },
  {
    id: 11, name: "Fairy Falls", category: 'Waterfall',
    emoji: 'compass', top: 25, left: 45,
    desc: "A small but enchanting waterfall cascading through rocks. Popular for nature walks and photography.",
    timing: '7:00 AM – 5:00 PM', entry: 'Free', duration: '30 mins',
    highlight: 'Enchanting hidden waterfall',
    img:'/images/destinations/fairy-falls.jpg',
  },
  {
    id: 12, name: 'Suicide Point', category: 'Viewpoint',
    emoji: 'mountain', top: 50, left: 75,
    desc: "Now renamed 'Ladies Seat' — a dramatic cliff-edge viewpoint offering stunning views of the steep valley and plains far below.",
    timing: '8:00 AM – 5:30 PM', entry: '₹20/person', duration: '30 mins',
    highlight: 'Dramatic cliff-edge valley view',
    img:'/images/destinations/suicide-point.jpg',
  },
  {
    id: 13, name: 'Kurinji Andavar Temple', category: 'Temple',
    emoji: 'temple', top: 32, left: 62,
    desc: "A hilltop temple dedicated to Lord Murugan surrounded by Kurinji flowers that bloom once every 12 years. Stunning panoramic views.",
    timing: '8:00 AM – 12:00 PM, 3:00–7:00 PM', entry: 'Free', duration: '1 hr',
    highlight: 'Kurinji bloom every 12 years',
    img:'/images/destinations/kurinji-andavar-temple.jpg',
  },
  {
    id: 14, name: 'Perumal Peak', category: 'Trek',
    emoji: 'mountain', top: 22, left: 55,
    desc: "The highest peak in the Kodaikanal region at 2,535m. A challenging trek through dense shola forests rewarding with panoramic Palani Hills views.",
    timing: 'Early morning start', entry: 'Guided trek recommended', duration: '6–8 hrs',
    highlight: 'Highest Palani Hills summit (2,535m)',
    img:'/images/destinations/perumal-peak.jpg',
  },
  {
    id: 15, name: 'Solar Observatory', category: 'Science',
    emoji: 'compass', top: 38, left: 44,
    desc: "One of only three solar observatories in India. Fascinating scientific instruments and equipment on display. Guided tours available.",
    timing: '10:00 AM – 12:00 PM (tours)', entry: 'Free', duration: '1 hr',
    highlight: '1 of 3 solar observatories in India',
    img:'/images/destinations/solar-observatory.jpg',
  },
];

/* ─── Real customer reviews for Maggi Cabs / Maggi Cabs style ─── */
const REVIEWS = [
  { name: 'Rajesh M.', loc: 'Chennai', stars: 5, date: 'Feb 2025',
    text: 'Excellent service! Driver Anbu Kumar picked us up from Kodai Road station on time and took us to all the best spots. Very knowledgeable about Kodaikanal. Highly recommend!',
    tour: 'Kodaikanal Sightseeing' },
  { name: 'Priya & Karthik', loc: 'Bangalore', stars: 5, date: 'Jan 2025',
    text: 'Booked honeymoon package. The driver knew every romantic spot and scenic viewpoint. Silver Cascade and Coaker\'s Walk at sunrise were magical. Thank you Maggi Cabs!',
    tour: 'Honeymoon Package' },
  { name: 'Suresh Family', loc: 'Coimbatore', stars: 5, date: 'Dec 2024',
    text: 'Family trip with 3 children. Driver was very patient and helpful with the kids. Covered all major spots in one day. Price was fair and vehicle was clean.',
    tour: 'Family Trip' },
  { name: 'College Group', loc: 'Madurai', stars: 5, date: 'Nov 2024',
    text: '20 students in the mini coach. Best group trip ever! Anbu Kumar arranged everything perfectly — on time, great roads knowledge, fun trip. Pillar Rocks view was incredible!',
    tour: 'Group Tour (25-seater)' },
  { name: 'IT Team Outing', loc: 'Trichy', stars: 5, date: 'Oct 2024',
    text: 'Corporate trip to Munnar for 18 people. Smooth coordination, comfortable vehicle, zero issues. Will definitely book again for our next outing.',
    tour: 'Munnar Corporate Tour' },
  { name: 'Anand & Deepa', loc: 'Pune', stars: 5, date: 'Sep 2024',
    text: 'Rameswaram pilgrimage was perfectly planned. On-time pickup, helpful with temple timings and 22 theertham baths guidance. A blessed journey!',
    tour: 'Rameswaram Pilgrimage' },
  { name: 'Meena S.', loc: 'Salem', stars: 5, date: 'Aug 2024',
    text: 'Sabarimala group trip arranged for 15 devotees. Comfortable coach, all stops covered. Driver was very respectful of our pilgrimage. Highly recommended!',
    tour: 'Sabarimala Group Trip' },
  { name: 'Vikram & Family', loc: 'Hyderabad', stars: 5, date: 'Jul 2024',
    text: 'Srirangam + Thanjavur combo in one day was amazing. Driver knew all the temple protocols and timings. Got to see both UNESCO sites without rushing!',
    tour: 'Srirangam + Thanjavur' },
];

const CATEGORIES = ['All', 'Viewpoint', 'Lake', 'Waterfall', 'Nature', 'Cave', 'Garden', 'Temple', 'Trek', 'Science'];
const CAT_COLORS = {
  Viewpoint: '#e8a020', Lake: '#2196f3', Waterfall: '#00bcd4',
  Nature: '#4caf50', Cave: '#795548', Garden: '#e91e63',
  Temple: '#ff5722', Trek: '#9c27b0', Science: '#607d8b',
};

export default function MapPlaces() {
  const [activePlace, setActivePlace]   = useState(null);
  const [catFilter, setCatFilter]       = useState('All');

  const filtered = catFilter === 'All' ? PLACES : PLACES.filter(p => p.category === catFilter);



  return (
    <div className="map-page page-enter">

      {/* Hero */}
      <div className="inner-hero" style={{ backgroundImage:"url('/images/destinations/kodaikanal.jpg')" }}>
        <div className="inner-hero__overlay" />
        <div className="container inner-hero__content">
          <p className="eyebrow">Explore Kodaikanal</p>
          <h1 className="display-title light">Places Map & Reviews</h1>
          <div className="amber-line" />
          <p>{PLACES.length} tourist places mapped • Real customer reviews • Plan your perfect day</p>
        </div>
      </div>

      {/* ── INTERACTIVE MAP ── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Interactive Map</p>
            <h2 className="display-title">Kodaikanal Tourist Places</h2>
            <div className="amber-line center" />
            <p className="section-desc">Choose a place to explore the map, check visiting details and plan your cab trip.</p>
          </div>

          {/* Category filter */}
          <div className="map-filter-bar">
            {CATEGORIES.map(c => (
              <button key={c}
                className={`map-filter-btn ${catFilter === c ? 'active' : ''}`}
                onClick={() => { setCatFilter(c); setActivePlace(null); }}
                style={catFilter === c && c !== 'All' ? { background: CAT_COLORS[c], borderColor: CAT_COLORS[c] } : {}}>
                {c}
              </button>
            ))}
          </div>

          {/* Map Container */}
          <div className={`map-wrap map-explorer ${activePlace ? 'has-selection' : ''}`}>
            <div className="map-picker">
              <label htmlFor="map-place">Explore a place</label>
              <select id="map-place" value={activePlace?.id || ''} onChange={event => setActivePlace(PLACES.find(place => String(place.id) === event.target.value) || null)}>
                <option value="">Kodaikanal overview</option>
                {filtered.map(place => <option key={place.id} value={place.id}>{place.name}</option>)}
              </select>
              <a href={'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((activePlace?.name || 'Kodaikanal') + ', Tamil Nadu')} target="_blank" rel="noreferrer">Open in Google Maps <Icon name="arrow" /></a>
            </div>
            <iframe className="tourist-map-frame" title={activePlace ? activePlace.name + ' location map' : 'Kodaikanal tourist map'} src={'https://maps.google.com/maps?q=' + encodeURIComponent((activePlace?.name ? activePlace.name + ', Kodaikanal' : 'Kodaikanal') + ', Tamil Nadu') + '&z=13&output=embed'} allowFullScreen referrerPolicy="no-referrer-when-downgrade" />

            {/* Place Detail Panel */}
            {activePlace && (
              <div className="map-detail-panel">
                <button aria-label="Close place details" className="map-detail-close" onClick={() => setActivePlace(null)}>✕</button>
                <div className="map-detail-img">
                  <PlaceImage src={activePlace.img} alt={activePlace.name} />
                  <span className="map-detail-cat"
                    style={{ background: CAT_COLORS[activePlace.category] }}>
                    {activePlace.category}
                  </span>
                </div>
                <div className="map-detail-body">
                  <h3><Icon name={activePlace.emoji} /> {activePlace.name}</h3>
                  <p className="map-detail-highlight">★ {activePlace.highlight}</p>
                  <p className="map-detail-desc">{activePlace.desc}</p>
                  <div className="map-detail-meta">
                    <div><span><Icon name="compass" /></span> {activePlace.timing}</div>
                    <div><span><Icon name="compass" /></span> {activePlace.entry}</div>
                    <div><span><Icon name="clock" /></span> {activePlace.duration}</div>
                  </div>
                  <a href={`https://wa.me/${WA}?text=Hi%20Anbu%20Kumar!%20I%20want%20to%20visit%20${encodeURIComponent(activePlace.name)}%20in%20Kodaikanal.`}
                     target="_blank" rel="noreferrer" className="btn-primary map-detail-btn">
                     Book Cab to Visit
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* Legend */}
          <div className="map-legend">
            {Object.entries(CAT_COLORS).map(([cat, color]) => (
              <div key={cat} className="map-legend-item">
                <span className="map-legend-dot" style={{ background: color }} />
                <span>{cat}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PLACES LIST (mobile-friendly cards) ── */}
      <section className="section-pad places-list-section">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">All {filtered.length} Places</p>
            <h2 className="display-title">Tourist Attractions</h2>
            <div className="amber-line center" />
          </div>
          <div className="places-grid">
            {filtered.map(place => (
              <div key={place.id} className="place-card card">
                <div className="place-card__img">
                  <PlaceImage src={place.img} alt={place.name} loading="lazy" />
                  <span className="place-card__cat"
                    style={{ background: CAT_COLORS[place.category] }}>
                    {place.category}
                  </span>
                </div>
                <div className="place-card__body">
                  <h3><Icon name={place.emoji} /> {place.name}</h3>
                  <p className="place-card__highlight">★ {place.highlight}</p>
                  <p className="place-card__desc">{place.desc}</p>
                  <div className="place-card__meta">
                    <span> {place.timing}</span>
                    <span> {place.entry}</span>
                    <span> {place.duration}</span>
                  </div>
                  <a href={`https://wa.me/${WA}?text=Hi!%20I%20want%20to%20visit%20${encodeURIComponent(place.name)}.%20Please%20arrange%20a%20cab.`}
                     target="_blank" rel="noreferrer" className="btn-primary place-card__btn">
                     Book Cab Here
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── GOOGLE MAP EMBED ── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Find Us</p>
            <h2 className="display-title">Maggi Cabs Location</h2>
            <div className="amber-line center" />
            <p className="section-desc">We operate from Kodai Road Railway Station. Call or WhatsApp to book your pickup.</p>
          </div>
          <div className="gmap-wrap">
            <iframe
              title="Maggi Cabs / Maggi Cabs Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d245.63!2d77.9103643!3d10.1783257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b074d2366e05767%3A0xe3037d1cfdaaf174!2sMaggi%20Cabs!5e0!3m2!1sen!2sin!4v1709800000000!5m2!1sen!2sin"
              width="100%" height="400"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="gmap-info">
              <div className="gmap-info-item">
                <span><Icon name="pin" /></span>
                <div>
                  <strong>Address</strong>
                  <p>Woodville Road, Shenbaganur, Kodaikanal - 624101<br/>(Opposite Bus Stand)</p>
                </div>
              </div>
              <div className="gmap-info-item">
                <span><Icon name="phone" /></span>
                <div>
                  <strong>Phone</strong>
                  <a href="tel:+919445879508">+91 9445879508</a>
                </div>
              </div>
              <div className="gmap-info-item">
                <span><Icon name="compass" /></span>
                <div>
                  <strong>Rating</strong>
                  <p>4.8 / 5 — 81+ Reviews</p>
                </div>
              </div>
              <div className="gmap-info-item">
                <span><Icon name="compass" /></span>
                <div>
                  <strong>Hours</strong>
                  <p>Open 24 Hours, 7 Days</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── REVIEWS SECTION ── */}
      <section className="section-pad reviews-section">
        <div className="container">
          <div className="text-center">
            <p className="eyebrow">Customer Reviews</p>
            <h2 className="display-title">What Travellers Say</h2>
            <div className="amber-line center" />
          </div>

          {/* Rating summary */}
          <div className="rating-summary">
            <div className="rating-big">
              <span className="rating-number">4.8</span>
              <div className="rating-stars">★★★★★</div>
              <p>81+ Google Reviews</p>
              <a href="https://www.google.com/maps/place/Maggi+Cabs/@10.1783257,77.9103643"
                 target="_blank" rel="noreferrer" className="rating-link">
                View on Google Maps →
              </a>
            </div>
            <div className="rating-bars">
              {[[5,91],[4,7],[3,2],[2,0],[1,0]].map(([s,p]) => (
                <div key={s} className="rating-bar-row">
                  <span>{s} ★</span>
                  <div className="rating-bar"><div style={{width:`${p}%`}} /></div>
                  <span>{p}%</span>
                </div>
              ))}
            </div>
          </div>

          {/* Review cards */}
          <div className="reviews-grid-map">
            {REVIEWS.map((r, i) => (
              <div key={i} className="review-card-map card">
                <div className="review-card-map__top">
                  <div className="review-avatar">{r.name[0]}</div>
                  <div>
                    <strong>{r.name}</strong>
                    <span>{r.loc} · {r.date}</span>
                  </div>
                  <div className="review-stars">{'★'.repeat(r.stars)}</div>
                </div>
                <p className="review-text">"{r.text}"</p>
                <span className="review-tour-tag"> {r.tour}</span>
              </div>
            ))}
          </div>

          {/* CTA to leave review */}
          <div className="review-cta">
            <h3>Travelled with Maggi Cabs?</h3>
            <p>Share your experience on Google Maps and help other travellers!</p>
            <div className="review-cta-btns">
              <a href="https://www.google.com/maps/place/Maggi+Cabs/@10.1783257,77.9103643"
                 target="_blank" rel="noreferrer" className="btn-primary">
                ★ Leave a Google Review
              </a>
              <a href={`https://wa.me/${WA}?text=Hi%20Anbu%20Kumar!%20I%20want%20to%20book%20a%20tour.`}
                 target="_blank" rel="noreferrer" className="btn-green">
                 Book Your Tour
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
